<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">nickname 신청정보</div>
        <div>
          <member-write-component :memberType="`curatorUpdate`" :memberKey="memberKey"></member-write-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberWriteComponent from "@/components/member/MemberWriteComponent";

export default {
  name: "CuratorUpdate",
  mixins: [],
  components: {
    MemberWriteComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      memberKey: Number(this.$route.params.idx),
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>